import { createFileRoute } from "@tanstack/react-router";
import MyApiKeysPage from "@/features/my-api-keys/MyApiKeysPage";

export const Route = createFileRoute("/_admin/my-api-keys")({
  component: MyApiKeysPage,
});
